import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { CheckoutSettings, WhiteLabelInfo } from "src/app/core/models/model";

@Component({
    selector: "app-card-token-view",
    templateUrl: "./card-token-view.component.html",
    styleUrls: ["./card-token-view.component.css"],
    standalone: false
})
export class CardTokenViewComponent implements OnInit {
  @Output() OTP = new EventEmitter<string>();
  @Input() otpError: string;

  otpForm: UntypedFormGroup;
  @Input() whiteLabelInfo: WhiteLabelInfo;

  @Output() emitResendOtp = new EventEmitter();

  constructor(private fb: UntypedFormBuilder) {
    this.otpForm = this.fb.group({
      otp: ["", Validators.required],
    });
  }

  ngOnInit() {}

  emitOtp() {
    this.OTP.emit(this.otpForm.value);
  }

  resendOtp() {
    this.emitResendOtp.emit();
  }
}
